import * as i from "react";
import { p as a } from "./index-efd35e77.js";
import { w as x, x as N } from "./index-93802845.js";
import { v as O, p as E, l as m, m as F, c as h } from "./package-metadata-3dcf116a.js";
var P = globalThis && globalThis.__extends || function() {
  var l = function(o, e) {
    return l = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(t, r) {
      t.__proto__ = r;
    } || function(t, r) {
      for (var s in r)
        Object.prototype.hasOwnProperty.call(r, s) && (t[s] = r[s]);
    }, l(o, e);
  };
  return function(o, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    l(o, e);
    function t() {
      this.constructor = o;
    }
    o.prototype = e === null ? Object.create(e) : (t.prototype = e.prototype, new t());
  };
}(), S = (
  /** @class */
  function(l) {
    P(o, l);
    function o(e) {
      var t = l.call(this, e) || this;
      return t.state = {
        focused: !1
      }, t.handleFocus = function(r) {
        t.setState({ focused: !0 });
      }, t.handleBlur = function(r) {
        t.setState({ focused: !1 });
      }, O(E), t;
    }
    return o.prototype.render = function() {
      var e = this.props, t = e.label, r = e.editorId, s = e.className, n = e.editorValue, b = e.editorPlaceholder, g = e.editorValid, c = e.editorDisabled, y = e.style, d = e.id, _ = e.optional, v = x(this), p = _ ? v.toLanguageString(m, F[m]) : "", u = p && i.createElement("span", { className: "k-label-optional" }, p), k = h({
        "k-floating-label-container": !0,
        "k-focus": this.state.focused,
        "k-empty": !b && !n && n !== 0,
        "k-text-disabled": c,
        "k-rtl": this.props.dir === "rtl"
      }, s), f = h({
        "k-label": !0,
        "k-text-error": g === !1,
        "k-text-disabled": c
      });
      return i.createElement(
        "span",
        { id: this.props.id, className: k, onFocus: this.handleFocus, onBlur: this.handleBlur, style: y, dir: this.props.dir },
        this.props.children,
        t ? r ? i.createElement(
          "label",
          { id: d, htmlFor: r, className: f },
          t,
          u
        ) : i.createElement(
          "span",
          { id: d, className: f },
          t,
          u
        ) : null
      );
    }, o.propTypes = {
      label: a.string,
      editorId: a.string,
      editorValue: a.oneOfType([a.string, a.bool, a.number]),
      editorPlaceholder: a.string,
      editorValid: a.bool,
      editorDisabled: a.bool,
      id: a.string,
      style: a.object,
      className: a.string,
      optional: a.bool
    }, o;
  }(i.Component)
);
N(S);
export {
  S as F
};
